import { buildUrlWithOrigin } from '@/utils/url';
import { isIOS, isSayWeeeApp } from './device';
import { getLang } from '@/utils/common/user';

export const openDefaultBrowserInWeeeApp = (link: string) => {
  const lang = getLang();

  if (!isSayWeeeApp()) return;
  if (isIOS()) {
    window.location.href = buildUrlWithOrigin(
      `/${lang}/open-external?pushto=native&open_external=${encodeURIComponent(link)}`
    );
  } else {
    window.location.href = `weee://open_external?url=${encodeURIComponent(link)}`;
  }
};
